import gql from 'graphql-tag';

export default gql`
    query createMultipartUpload($bucketKey: String!, $fileType: String!, $organisationId: String!) {
        createMultipartUpload(bucketKey: $bucketKey, fileType: $fileType, organisationId: $organisationId)
    }
`;